/**
 * Format a Date as YYYY-MM-DD using LOCAL getters.
 *
 * For a date the user picked out of a calendar widget, the local calendar day
 * IS the answer — `toISOString()` reinterprets that instant in UTC and lands on
 * the previous day for anyone east of UTC, which is how a birthdate gets stored
 * one day early. Pair this with the API's `parseBirthdate`, which accepts
 * YYYY-MM-DD and normalizes to UTC midnight.
 */
export function toIsoDateLocal(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}
